import { ReactNode } from 'react';
import styled from 'styled-components';
import { heading4 } from 'ui/theme';
import { plusHalf } from 'ui/theme/spacing';
import { CollapsibleContentArrow } from 'ui/collapsibleContent';

type Props = {
  /** Content displayed within the accordion label */
  children?: ReactNode;
  /** Whether the parent accordion is expanded or not */
  isExpanded?: boolean;
  /** Optional text label to be displayed */
  label?: string;
  arrowHeight?: number;
  arrowWidth?: number;
  /** Optional arrow start and end directions */
  arrowStart?: number;
  arrowEnd?: number;
};

const LabelHeader = styled.p(heading4);

const StyledAccordionLabel = styled(LabelHeader)`
  margin: 0;
`;

const LabelButton = styled.button`
  width: 100%;
  background: none;
  border: none;
  display: flex;
  justify-content: space-between;
  padding: ${plusHalf};
`;

/**
 * @deprecated
 * this accordion implementation has been deprecated. please use ui/AccordionHeader in addition to ui/Accordion
 * */
const AccordionLabelDeprecated = ({
  children,
  label,
  arrowStart,
  arrowEnd,
  isExpanded = false,
  arrowHeight = 24,
  arrowWidth = 24,
  ...props
}: Props) => (
  <LabelButton data-test="accordion-label" {...props}>
    {label && <StyledAccordionLabel>{label}</StyledAccordionLabel>}
    {!label && children}
    <CollapsibleContentArrow
      height={arrowHeight}
      width={arrowWidth}
      isCollapsed={!isExpanded}
      arrowStart={arrowStart}
      arrowEnd={arrowEnd}
    />
  </LabelButton>
);

export default AccordionLabelDeprecated;
